import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import MaterialInput from "@Shared/components/inputs/material-input";
import Select2 from "@Shared/components/inputs/select2.vue";
import PhoneInput from "@Shared/components/inputs/phone-input";
import { INVITE_AGENT } from "../store/agent-actions";
import { mapActions, mapState } from "vuex";
import { showToast } from "@Shared/@Utils/constants";
import Err from "@Broker/@Routes/error";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddAgentModal",
  title() {
    return this.$t("sidebar.sections.agents");
  },
  components: {
    GenericModal,
    SimpleButton,
    MaterialInput,
    PhoneInput,
    Select2
  },
  mixins: [validationMixin],
  validations: {
    givenName: {
      required
    },
    familyName: {
      required
    },
    phoneNumber: {
      required
    },
    email: {
      required,
      email
    },
    userType: {
      required
    },
    userLanguage: {
      required
    }
  },
  data() {
    const userLanguages = [{
      id: "en-CA",
      text: this.$t("account.english"),
      value: "en-CA"
    }, {
      id: "fr-CA",
      text: this.$t("account.french"),
      value: "fr-CA"
    }];
    const userTypes = [{
      id: 1,
      text: this.$t("global.words.broker"),
      value: "broker"
    }, {
      id: 2,
      text: this.$t("global.words.agent"),
      value: "agent"
    }];
    return {
      givenName: "",
      familyName: "",
      phoneNumber: "",
      email: "",
      loading: false,
      loadingSucceeded: null,
      userType: null,
      userLanguage: null,
      userLanguages,
      userTypes
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", {
    portalLocale: state => state.accountDetails.localeLanguage
  })), {}, {
    canSubmit() {
      return !(this.$v.$invalid || this.loading);
    }
  }),
  mounted() {
    var _context;
    this.userLanguage = _findInstanceProperty(_context = this.userLanguages).call(_context, lang => lang.id === this.portalLocale);
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AgentStore", [INVITE_AGENT])), {}, {
    resetData() {
      this.givenName = "";
      this.familyName = "";
      this.phoneNumber = "";
      this.email = "";
      this.userType = null;
      this.$v.$reset();
    },
    openModal() {
      this.$showModal();
    },
    closeModal() {
      this.$hideModal();
    },
    async handleSubmit() {
      this.loading = true;
      try {
        var _this$userType, _this$userLanguage;
        await this.INVITE_AGENT({
          details: {
            givenName: this.givenName,
            familyName: this.familyName,
            email: this.email,
            phoneNumber: this.phoneNumber,
            userType: (_this$userType = this.userType) == null ? void 0 : _this$userType.value,
            userLanguage: (_this$userLanguage = this.userLanguage) == null ? void 0 : _this$userLanguage.value
          }
        });
        showToast("success", "agentInvited");
        this.loadingSucceeded = true;
        Amplitude.logEvent("Agents - new agent invited", {
          page: "agents",
          subpage: "add-agent",
          data: {
            email: this.email
          }
        });
      } catch (e) {
        Err.handle(e);
        this.loadingSucceeded = false;
      }
      this.loading = false;
    },
    handleShow() {
      Amplitude.logEvent(`Agents - add agent visited`, {
        page: "agents",
        subpage: "add-agent"
      });
    }
  })
});